import $ from "jquery"
import CryptoJS from "crypto-js";
import shareds from '@/assets/js/shared'
class ApiService {
    //物件建立時產生
    constructor(vue){
        this.url = process.env.VUE_APP_API_URL
        this.key = 'c4e1u12d45e83f78535dkb86bah50f4a'
        this.header = {}
        this.isDecryption = false
        this.userData = {}
        this.token = ""
        this.router = vue.$router; // 保存 router 實例
        this.debug = vue.$debug; // 保存 router 實例
        this.shared = new shareds()
    }

    init(data){ //初始化header
        this.header = {
            token:data.token
        }
    }
    //user Token 處理成32長度
    getUserToken(token){
        let hToken = token.substr(0,16)
        let fToken = token.substr(token.length-16,token.length)
        return hToken+fToken
    }
    setToken(token){
        this.token = token;
        this.header = {
            token: this.token
        }
    }
    getToken(){
        return this.token;
    }
    //解密
    AES_ECB_DECRYPT(token) {
        if(token==''){
            return;
        }
        var decrypt = CryptoJS.AES.decrypt(
            token, 
            CryptoJS.enc.Utf8.parse(this.key),
            {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            }
        );
        return decrypt.toString( CryptoJS.enc.Utf8 )
    }
    //資料加密
    AES_ECB_ENCRYPT(parameter){
        let encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(JSON.stringify(parameter)), CryptoJS.enc.Utf8.parse(this.key), { 
            iv:CryptoJS.enc.Utf8.parse(this.iv),
            mode: CryptoJS.mode.ECB, 
            padding: CryptoJS.pad.Pkcs7
        }); 
        return encrypted.ciphertext.toString(CryptoJS.enc.Base64)
    }
    //api請求body資料加密
    apiDataEncrypt(parameter){
        if ( this.isDecryption ){ //需要加密
            parameter = {
                data:this.AES_ECB_ENCRYPT(parameter)
            }
            parameter = JSON.stringify(parameter)
        }else{ //資料不需要加密
            // parameter = JSON.stringify(parameter)
        }
        return parameter
    }
    //api回應資料解密
    apiDataDecrypt(parameter){
        if ( this.isDecryption ){ //需要解密
            parameter = JSON.parse( this.AES_ECB_DECRYPT(parameter.data) )
        }
        return parameter
    }
    //處理login&註冊時產生token
    userInputEncrypt(){
        let token = CryptoJS.lib.WordArray.random(128/8).toString(CryptoJS.enc.Hex)
        return token
    }
    //get加密
    getMethodEncryp(parameter=null){
        if (parameter==null){
            return ''
        }
        if ( this.isDecryption ){ //需要加密
            parameter = {
                data:this.AES_ECB_ENCRYPT(parameter)
            }
            parameter = "data="+parameter
        }else{ //資料不需要加密
            // parameter = JSON.stringify(parameter)
            let url = ''
            Object.keys(parameter).forEach((key) => {
                url = url+key+'='+parameter[key]+'&'
            });
            parameter =  url.substring(0, url.length - 1);
        }
        return parameter
    }
    //執行POST
    postApi(data){ 
        let self = this
        $.ajax({
            url: data.url,              // 要傳送的頁面
            method: 'POST',               // 使用 POST 方法傳送請求
            dataType: 'json',             // 回傳資料會是 json 格式
            headers:self.header,
            // contentType : 'application/json; charset=utf-8', // 要送到server的資料型態
            data: self.apiDataEncrypt(data.parameter),
            success: function(res){
                console.log(res)
                // 成功以後會執行這個方法
                res = self.apiDataDecrypt(res)
                data.success(res)
            },
            xhr: function(){
                var xhr = new window.XMLHttpRequest(); // 建立xhr(XMLHttpRequest)物件
                xhr.upload.addEventListener("progress", function(progressEvent){ // 監聽ProgressEvent
                    if (progressEvent.lengthComputable) {
                        var percentComplete = progressEvent.loaded / progressEvent.total;
                        var percentVal = Math.round(percentComplete*100);
                        if ( data.progress ){
                            console.log("上傳進度為：" + progressEvent.loaded + " of " + progressEvent.total + " bytes" + '；百分比為：' + progressEvent.loaded/progressEvent.total); 
                            data.progress({
                                mag:"上傳進度為：" + progressEvent.loaded + " of " + progressEvent.total + " bytes" + '；百分比為：' + progressEvent.loaded/progressEvent.total,
                                loaded:progressEvent.loaded,
                                total:progressEvent.total,
                                percentComplete:percentComplete,
                                percentVal:percentVal
                            })
                        }   
                    }
                },false);
                return xhr; // 注意必須將xhr(XMLHttpRequest)物件回傳
            },
            error: function(err){
                // console.log(err)
                data.error({code:500,msg:'伺服器請求異常'})
            }
        })
    }
    postFormDataApi(data){ 
        let self = this
        $.ajax({
            url: data.url,              // 要傳送的頁面
            method: 'POST',               // 使用 POST 方法傳送請求
            dataType: 'json',             // 回傳資料會是 json 格式
            headers:self.header,
            data:data.parameter,  // 將表單資料用打包起來送出去
            contentType: false,
            cache: false,
            processData:false,
            success: function(res){
                // console.log(res)
                // 成功以後會執行這個方法
                res = self.apiDataDecrypt(res)
                // if (res.code < 0 ){
                //     alert('error['+res.code +'] : ' + res.message )
                // }
                if(res.code==-9999){
                    alert(res.msg);
                }
                data.success(res)
            },
            xhr: function(){
                var xhr = new window.XMLHttpRequest(); // 建立xhr(XMLHttpRequest)物件
                xhr.upload.addEventListener("progress", function(progressEvent){ // 監聽ProgressEvent
                    if (progressEvent.lengthComputable) {
                        var percentComplete = progressEvent.loaded / progressEvent.total;
                        var percentVal = Math.round(percentComplete*100);
                        if ( data.progress ){
                            console.log("上傳進度為：" + progressEvent.loaded + " of " + progressEvent.total + " bytes" + '；百分比為：' + progressEvent.loaded/progressEvent.total); 
                            data.progress({
                                mag:"上傳進度為：" + progressEvent.loaded + " of " + progressEvent.total + " bytes" + '；百分比為：' + progressEvent.loaded/progressEvent.total,
                                loaded:progressEvent.loaded,
                                total:progressEvent.total,
                                percentComplete:percentComplete,
                                percentVal:percentVal
                            })
                        }   
                    }
                },false);
                return xhr; // 注意必須將xhr(XMLHttpRequest)物件回傳
            },
            error: function(err){
                // console.log(err)
                data.error({code:500,msg:'伺服器請求異常'})
            }
        })
    }
    //執行PUT
    putApi(data){
        let self = this
        $.ajax({
            url: data.url,              // 要傳送的頁面
            method: 'PUT',               // 使用 POST 方法傳送請求
            dataType: 'json',             // 回傳資料會是 json 格式
            headers:self.header,
            contentType : 'application/json; charset=utf-8', // 要送到server的資料型態
            data: self.apiDataEncrypt(data.parameter),
            success: function(res){
                // console.log(res)
                // 成功以後會執行這個方法
                res = self.apiDataDecrypt(res)
                // if (res.code < 0 ){
                //     alert('error['+res.code +'] : ' + res.message )
                // }
                data.success(res)
            },
            xhr: function(){
                var xhr = new window.XMLHttpRequest(); // 建立xhr(XMLHttpRequest)物件
                xhr.upload.addEventListener("progress", function(progressEvent){ // 監聽ProgressEvent
                    if (progressEvent.lengthComputable) {
                        var percentComplete = progressEvent.loaded / progressEvent.total;
                        var percentVal = Math.round(percentComplete*100);
                        if ( data.progress ){
                            console.log("上傳進度為：" + progressEvent.loaded + " of " + progressEvent.total + " bytes" + '；百分比為：' + (progressEvent.loaded/progressEvent.total)*100+'%'); 
                            data.progress({
                                mag:"上傳進度為：" + progressEvent.loaded + " of " + progressEvent.total + " bytes" + '；百分比為：' + (progressEvent.loaded/progressEvent.total)*100+'%',
                                loaded:progressEvent.loaded,
                                total:progressEvent.total,
                                percentComplete:percentComplete,
                                percentVal:percentVal
                            })
                        }   
                    }
                },false);
                return xhr; // 注意必須將xhr(XMLHttpRequest)物件回傳
            },
            error: function(err){
                console.log(err)
                data.error({code:500,msg:'伺服器請求異常'})
            }
        })
    }
    //執行GET
    getApi(data){
        let self = this
        if (data.parameter){
            data.url = data.url+"?"+this.getMethodEncryp(data.parameter)
        }
        $.ajax({
            url: data.url,              // 要傳送的頁面
            method: 'GET',               // 使用 GET 方法傳送請求
            dataType: 'json',             // 回傳資料會是 json 格式
            headers:self.header,
            success: function(res){
                // 成功以後會執行這個方法
                // if (res.code < 0 ){
                //     alert('error['+res.code +'] : ' + res.message )
                // }
                if(res.code==-9999){
                    alert(res.msg);
                }
                data.success(res)
            },
            error: function(err){
                console.log(err)
                data.error({code:500,msg:'伺服器請求異常'})
            }
        })
    }

    //執行DELECT
    delApi(data){
        let self = this
        $.ajax({
            url: data.url,              // 要傳送的頁面
            method: 'DELETE',               // 使用 POST 方法傳送請求
            dataType: 'json',             // 回傳資料會是 json 格式
            headers:self.header,
            data:data.parameter,  // 將表單資料用打包起來送出去
            contentType: false,
            cache: false,
            processData:false,
            success: function(res){
                console.log(res)
                // 成功以後會執行這個方法
                res = self.apiDataDecrypt(res)
                // if (res.code < 0 ){
                //     alert('error['+res.code +'] : ' + res.message )
                // }
                if(res.code==-9999){
                    alert(res.msg);
                }
                data.success(res)
            },
            error: function(err){
                console.log(err)
                data.error({code:500,msg:'伺服器請求異常'})
            }
        })
    }

    /*
    api區
    */
    //取得測試資料
    getTestTableAPI(parameter,callback){
        //呼叫post方法
        this.getApi({
            url:this.url+"patient/list",
            parameter:parameter,
            success:function(res){
                callback(res)
            }
        })
    }

    async simulationAPI(){
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({code:200,msg:'success'})
            }, 1000);
        })
    }

    //取得viewer的模型資料物件
    async getViewerData(url,parameter=null){
        return new Promise((resolve, reject) => {
            this.getApi({
                url:`${process.env.VUE_APP_FILE_SERVER_URL}file/getViewerData/${url}`,
                parameter:parameter,
                success:function(res){
                    resolve(res)
                },
                error:(err)=>[
                    reject(err)
                ]
            })
        })
    }    

    async getPlanByNo(parameter=null){
        return new Promise((resolve, reject) => {
            this.getApi({
                url:`${this.url}/api/viewer/getPlanByNo`,
                parameter:parameter,
                success:function(res){
                    resolve(res)
                },
                error:(err)=>[
                    reject(err)
                ]
            })
        })
    }


}
export default ApiService